(function () {

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function getStickyButton() {
    return document.querySelector(".buynow-sticky");
  }

  function getSales() {
    return document.getElementById("sales-notifications");
  }

  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== "none" &&
           style.visibility !== "hidden" &&
           style.opacity !== "0";
  }

  function update() {
    const btn = getStickyButton();
    const sales = getSales();

    if (!btn || !sales) return;

    const stickyActive = isVisible(btn);

    if (isMobile() && stickyActive) {
      sales.style.display = "none";
    } else {
      sales.style.display = "";
    }
  }

  setInterval(update, 300);

  window.addEventListener("resize", update);
  document.addEventListener("DOMContentLoaded", update);

})();